export var Placement;

!function(Placement) {
    Placement.top = "top", Placement.bottom = "bottom", Placement.left = "left", Placement.right = "right";
}(Placement || (Placement = {}));

export var HierarchyState;

!function(HierarchyState) {
    HierarchyState.expand = "expand", HierarchyState.collapse = "collapse", HierarchyState.none = "none", 
    HierarchyState.loading = "loading";
}(HierarchyState || (HierarchyState = {}));
//# sourceMappingURL=table-engine.js.map
